module.exports = __webpack_public_path__ + "static/keyflow1-686a56d60c4eb1c096fc9c478f9456ea.mp4";